import { RelationalCopySource } from './../../../pipeline/copysource/relational.copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from '../../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(RelationalCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class RelationalCopySourceAdapter extends CopySourceAdapter<RelationalCopySource, Model.RelationalSource> {
    protected override async _toResource(copySource: RelationalCopySource): Promise<Model.RelationalSource> {
        const result: Model.RelationalSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(RelationalCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, RelationalCopySource.READER_QUERY);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.RelationalSource,
        copyActivity: CopyActivity
    ): Promise<RelationalCopySource> {
        return this._toTabularModel(resource, copyActivity, RelationalCopySource.MODEL);
    }
}
